{
    "accounts-sso_disconnect": {
        "title": "SSO",
        "summary": "You can only have one SSO provider, to change to another provide you need to disconnect from this one first.",
        "text": ""
    },
    "activate-account-marketing-email": {
        "title": "Verify email address",
        "summary": "Please verify the email address you signed up with.",
        "text": ""
    },
    "activate-account-passcode": {
        "title": "Activation Passcode",
        "summary": "The code displayed to your administrator during account creation.",
        "text": ""
    },
    "adcs-add_address": {
        "title": "ADC Address",
        "summary": "The hostname (FQDN) or IP address of this ADC.",
        "text": ""
    },
    "adcs-add_label": {
        "title": "ADC Label",
        "summary": "The name of this ADC to identify it in tables and lists.",
        "text": ""
    },
    "adcs-add_password": {
        "title": "ADC Password",
        "summary": "The password of this ADC.",
        "text": ""
    },
    "adcs-add_port": {
        "title": "ADC Port",
        "summary": "The port of this ADC.",
        "text": ""
    },
    "adcs-add_namespace": {
        "title": "Namespace",
        "summary": "Assign your ADC to a namespace.",
        "text": ""
    },
    "adcs-add_shuttle": {
        "title": "ADC Shuttle",
        "summary": "Select the shuttle that is on the network of this ADC.",
        "text": ""
    },
    "adcs-add_username": {
        "title": "ADC Username",
        "summary": "The username of this ADC.",
        "text": ""
    },
    "free-trial-md5-download": {
        "title": "MD5",
        "summary": "Download MD5 data."
    },
    "free-trial-sha-download": {
        "title": "SHA",
        "summary": "Download SHA data."
    },
    "namespace": {
        "title": "Namespace",
        "summary": "Namespace enables you to identify a group of products.",
        "text": ""
    },
    "org-name-add": {
        "title": "Name of your organisation",
        "summary": "Enter the name of your organisation, it must be at least 3 characters.",
        "text": ""
    },
    "org-user-invite-confirm-email": {
        "title": "Confirm Recipient's Email Address",
        "summary": "Please ensure that this email address matches the recipient's email address above.",
        "text": ""
    },
    "org-user-invite-email": {
        "title": "Recipient's Email Address",
        "summary": "The email address of the user being invited to this organisation.",
        "text": ""
    },
    "org-user-invite-permissions": {
        "title": "Recipient's Permissions",
        "summary": "Assign permissions to the recipient.",
        "text": ""
    },
    "product-type": {
        "title": "Product Type",
        "summary": "The type of product e.g. ADC",
        "text": ""
    },
    "schedule-type": {
        "title": "Schedule Type",
        "summary": "The type of schedule e.g. Backup, Update",
        "text": ""
    }
}
